import { addDays } from '~/util/date';
import { getInitialValues } from '~/libraries/forms/values';
import type { FullInterventionDefinitionViewModel, InterventionDefinitionViewModel } from '@generated';
import { isFullInterventionDefinition } from '../util';

const today = new Date();

export function getInterventionDefinitionInitialValues(
	interventionDefinition: FullInterventionDefinitionViewModel | InterventionDefinitionViewModel,
	assignedDisciplineIds: number[],
	projectedEndDateForNewInterventions?: Date,
	initialValues?: Record<string, string>
) {
	return {
		projectedStartDate: today,
		projectedEndDate: !projectedEndDateForNewInterventions
			? addDays(today, 1)
			: addDays(today, 30) > projectedEndDateForNewInterventions
			? projectedEndDateForNewInterventions
			: addDays(today, 30),
		assignedDisciplineIds: assignedDisciplineIds,
		homeHealthAideInterventionFrequencyTypeId: null,
		...(isFullInterventionDefinition(interventionDefinition) ? getInitialValues(interventionDefinition.definitionFormFields, initialValues) : {})
	};
}
